module.exports = __webpack_public_path__ + "img/17.bf4f445b.jpg";